import type { ElementOrFactory } from '@hive/component';
import type { HiveReference } from '@blocksuite/hive/inlines/reference';
import { ReferenceNodeConfigExtension } from '@blocksuite/hive/inlines/reference';
import type { ExtensionType } from '@blocksuite/hive/store';
import type { TemplateResult } from 'lit';

export type ReferenceReactRenderer = (
  reference: HiveReference
) => React.ReactElement;

export function patchReferenceRenderer(
  reactToLit: (element: ElementOrFactory) => TemplateResult,
  reactRenderer: ReferenceReactRenderer
): ExtensionType {
  const customContent = (reference: HiveReference) => {
    const node = reactRenderer(reference);
    return reactToLit(node);
  };

  return ReferenceNodeConfigExtension({
    customContent,
    hidePopup: BUILD_CONFIG.isMobileEdition,
  });
}
